import React from 'react';
import { Typography, Divider } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { Box } from '@mui/material';
import { formatToLocalDateTime } from '../../../utils/dateFormatter';
import EditIcon from '@mui/icons-material/Edit';
import { formatUtcToLocal } from '../../../utils/formatUtcToLocal';
import { useTranslation } from 'react-i18next';
import CopyButton from '../../common/controls/CopyButton';
import RequirePermission from '../../RequirePermission';
import { SUB_MODULES } from '../../../constants/subModulesConstants';
import CallSmsButtonCombo from '../../common/controls/CallSMSButtonCombo';

export default function AppointmentView({handleEdit, open, onClose, appointment = null}) { 
    const { t } = useTranslation('common'); 
    const handleClose = () => {
        onClose();
    };

    const handleEditClick = () => {
        handleEdit(appointment);
    };

    if (!appointment) {
        return (
            <></>
        );
    }

    return (
        <React.Fragment>
        <Dialog onClose={handleClose} open={open} disableRestoreFocus>
            
            <DialogTitle>Appointment</DialogTitle>
            <DialogContent dividers>
                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>{t('appointments.messages.no_delete')}</Typography>
                <Divider sx={{my: 2}} />
                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Patient</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{`${appointment.pet.name} (${appointment.petOwner.first_name} ${appointment.petOwner.last_name})`}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Contact Number</Typography>
                <Box display="inline-flex" alignItems="center">
                  <Typography variant="body1" sx={{ mt: 0 }}>{`${appointment.petOwner.contact_number}`}</Typography>
                  <CopyButton text={appointment.petOwner.contact_number} />
                </Box>
                <CallSmsButtonCombo phoneNumber={appointment.petOwner.contact_number} bodyText={`Hello ${appointment.petOwner.first_name},`} />

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>E-mail</Typography>
                <Box display="inline-flex" alignItems="center">
                  <Typography variant="body1" sx={{ mt: 0 }}>{`${appointment.petOwner.email}`}</Typography>
                  <CopyButton text={appointment.petOwner.email} />
                </Box>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Date and Time</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{formatUtcToLocal(appointment.datetime, 'date')}</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{formatUtcToLocal(appointment.datetime, 'time')}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Status</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{appointment.status.name}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Remarks to Patient</Typography>
                <Typography variant="body1" sx={{ mt: 0, whiteSpace: 'pre-line' }}>{appointment.remarks}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Created</Typography>
                <Typography variant="body2" sx={{ mt: 0 }}>{formatToLocalDateTime(appointment.createdAt)}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Last Updated</Typography>
                <Typography variant="body2" sx={{ mt: 0 }}>{formatToLocalDateTime(appointment.updatedAt)}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>User</Typography>
                <Typography variant="body2" sx={{ mt: 0 }}>{appointment.user.name}</Typography>

            </DialogContent>
            <DialogActions>
              <RequirePermission subModuleName={SUB_MODULES.APPOINTMENTS} minAccessLevel={2}>
                <Button disabled={appointment.status_id === 3 || appointment.status_id === 4 || appointment.status_id === 5 || appointment.status_id === 6} onClick={handleEditClick}>
                  <EditIcon />
                </Button>
              </RequirePermission>
              <div style={{flex: '1 0 0'}} />
              <Button onClick={handleClose}>Close</Button>
            </DialogActions>
        </Dialog>
        </React.Fragment>
    );
}